import { render, staticRenderFns } from "./RemoteFile.vue?vue&type=template&id=5470ff22"
import script from "./RemoteFile.vue?vue&type=script&lang=js"
export * from "./RemoteFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports